import axios from 'axios';
import get from 'lodash/get';

// Libs
import { Consequence } from '../../libs/utils';

// Endpoints
import { CURRENCY_RATES } from '../../constants/endpoints';

// ActionTypes
export const NEW_RATE_CURRENCIES = 'NEW_RATE_CURRENCIES';

export function getCurrencyRates() {
  return dispatch => axios.get(CURRENCY_RATES)
    .then(res => {
      const data = get(res, 'data.data', [])
      const currencyOptions = data.map((currency) => ({
        ...currency,
        value: get(currency, 'currency'),
        label: `${get(currency, 'currency')} - ${get(currency, 'description')}`
      }))

      return new Consequence({
        dispatch,
        payload: { data:  currencyOptions },
        eventTypes: { success: NEW_RATE_CURRENCIES, error: 'ERROR' }
      })

    })

} // END getCurrencyRates



// WEBPACK FOOTER //
// ./src/redux/actions/currencyActions.js